import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Features from '../components/Features';
import WhyBousanm from '../components/WhyBousanm';
import ProductOverview from '../components/ProductOverview';
import TargetAudience from '../components/TargetAudience';
import ComplianceSection from '../components/ComplianceSection';
import Waitlist from '../components/Waitlist';
import Footer from '../components/Footer';

import AboutUs from '../components/AboutUs';
import SEO from '../components/SEO';

function HomePage() {
    return (
        <>
            <SEO />
            <Navbar />
            <main>
                <Hero />
                <Features />
                <WhyBousanm />
                <ProductOverview />
                <TargetAudience />
                <AboutUs />
                <ComplianceSection />
                <Waitlist />
            </main>
            <Footer />
        </>
    );
}

export default HomePage;
